import { render } from "./css-chapter-4.vue?vue&type=template&id=633c98a2"
import script from "./css-chapter-4.vue?vue&type=script&lang=js"
export * from "./css-chapter-4.vue?vue&type=script&lang=js"

import "./css-chapter-4.vue?vue&type=style&index=0&id=633c98a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__